import React, { useEffect, useState } from 'react'
import UtilityService from '../../services/UtillityServices/UtilityService';
import useAgenzie from '../../hooks/useAgenzie';
import HorizontalCourseCard from '../HorizontalCourseCard/HorizontalCourseCard';
import { ROLES } from '../../model/roles';
import CustomSlider from '../CustomSlider/CustomSlider';
import { alertService } from '../../services/AlertService';
import useClassi from '../../hooks/useClassi';
import CustomSearch from '../CustomSearch/CustomSearch';
import useSconti from '../../hooks/useSconti';
import useVoucher from '../../hooks/useVoucher';
import useSuperpartner from '../../hooks/useSuperpartner';
import { Spinner, Alert, Card, Accordion, Badge } from 'react-bootstrap';
import useVoucherSuperpartnerCorsista from '../../hooks/useVoucherSuperpartnerCorsista';

const CreateUser = ({selectedAgenzia, setSelectedAgenzia, userLoggedIn, formCreateUtente, setFormCreateUtente, showModalCreateUtente, corsiUtentiAssignedPerUser, setCorsiUtentiAssignedPerUser, formatCourseData, isAssignmentOnly = false}) => {
  const [rolesList, setRolesList] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [maxScontoPartner, setMaxScontoPartner] = useState(null);
  const [remainingVoucherPartner, setVoucherPartner] = useState(null);//NEW
  const [idActiveVoucherPartner, setActiveVoucherPartner] = useState(null);//NEW
  const { getScontoByIdCorso, loadingStateSconti } = useSconti();
  const { getVoucherByIdCorso, findVoucherDisponibiliByIdAgenzia, loadingStateVoucher } = useVoucher();  
  const { getVoucherStock, isLoading: isLoadingSPVoucher } = useVoucherSuperpartnerCorsista();
  const {getAllSuperpartner, loadingStateSuperpartner} = useSuperpartner();
  const {getAgenzieByParams} = useAgenzie();
  const { getClassiByParamsNoAuth } = useClassi();
  const [paymentOption, setPaymentOption] = useState('self');
  const [voucherOption, setVoucherOption] = useState("1");
  const [selfOption, setSelfOption] = useState("1");//NEW
  const [shouldAssignCourse, setShouldAssignCourse] = useState(false);
  const [showAgenzieList, setShowAgenzieList] = useState(false);
  const [classiDisponibili, setClassiDisponibili] = useState([]);
  const [superpartnerList, setSuperpartnerList] = useState([]);
  const [voucher, setVoucher] = useState(null); // Stato per l'intero oggetto voucher (compatibilità)
  const [vouchersList, setVouchersList] = useState([]); // Stato per tutti i voucher disponibili per il corso

  useEffect(() => {
      if(!showModalCreateUtente) {
          setFormCreateUtente({});
      }
    }, [showModalCreateUtente])  

    useEffect(() => {
      if(selectedRole === "partner" || selectedRole === "superpartner") {
        fetchSuperpartner();
      }
    }, [selectedRole])  

  useEffect(() => {
      const rolesList = UtilityService.rolesAllowedToCreate(userLoggedIn);
      setRolesList(rolesList);
  }, [])

  useEffect(() => {
    if(!showAgenzieList){
      setSelectedAgenzia(null);
      setFormCreateUtente({...state => delete state.id_agenzia})
    }
  }, [showAgenzieList])

  useEffect(() => {
    if(selectedAgenzia) {
      setFormCreateUtente((prevState) => ({ ...prevState, id_agenzia: selectedAgenzia?.id_agenzia }));
    }
  }, [selectedAgenzia])

   useEffect(() => {
        // Se un corso viene selezionato...
        if (selectedCourse) {
            // ...controlla il ruolo dell'utente loggato.
            if (userLoggedIn.role === ROLES.PARTNER) {
                fetchVoucherPartner();
            } else if (userLoggedIn.role === ROLES.SUPERPARTNER) {
                fetchVoucherSuperpartner();
            }
            fetchMaxScontoPartner(); // Questa può rimanere comune per ora
        } else {
            // Se il corso viene deselezionato, pulisci i dati
            setMaxScontoPartner(null);
            setVoucher(null);
            setVouchersList([]);
        }
    }, [selectedCourse]); // L'unica dipendenza ora è il corso selezionato


    useEffect(() => {//NEW
      if (formatCourseData) {
        setSelectedCourse(formatCourseData);
        if ((userLoggedIn.tipo_utente === "partner" || userLoggedIn.tipo_utente === "superpartner") && selfOption === "0") {
          fetchVoucherPartner();
        }
      }
    }, [formatCourseData, userLoggedIn.tipo_utente, selfOption]);

  useEffect(() => {
    if(selectedCourse && (userLoggedIn.tipo_utente === "partner" || userLoggedIn.tipo_utente === "superpartner") && paymentOption === "corsista" && voucherOption === "1") {
      fetchMaxScontoPartner();
    }
  }, [paymentOption])

  useEffect(() => {
    const fetchClassiDisponibili = async () => {
      if (userLoggedIn?.role === ROLES.PARTNER || userLoggedIn?.role === ROLES.SUPERPARTNER) {
        const response = await getClassiByParamsNoAuth({//NEW
                                                        filtri: {
                                                          stato: 'Attivo'
                                                        },
                                                        usern: localStorage.getItem("username")//NEW
                                                      });
        setClassiDisponibili(response?.data ?? []);
      }
    };
    fetchClassiDisponibili();
  }, [userLoggedIn]);

  useEffect(() => {//NEW
    if (userLoggedIn.role === ROLES.PARTNER) {
        setFormCreateUtente((prevState) => ({ ...prevState, ruolo: "corsista" }));
        setSelectedRole("corsista");
    }
  }, [userLoggedIn]);

  useEffect(() => {//NEW
    if (formatCourseData && formatCourseData.id_classe) {
      setSelectedCourse(formatCourseData);  // Pre-seleziona il corso passato
    }
  }, [formatCourseData]);

  useEffect(() => {
    if (isAssignmentOnly && formCreateUtente?.ruolo) {
      setSelectedRole(formCreateUtente.ruolo);
    }
  }, [isAssignmentOnly, formCreateUtente?.ruolo]);

  const fetchSuperpartner = async () => {
    const response = await getAllSuperpartner();
    setSuperpartnerList(response ?? []);
  }

  const fetchMaxScontoPartner = async () => {
    const response = await getScontoByIdCorso({id_corso: selectedCourse?.corso.id_corso});
    setMaxScontoPartner(response?.sconto);
  }

  const fetchVoucherPartner = async () => {
      if (selectedCourse?.corso?.id_corso && userLoggedIn?.id_agenzia) {
          try {
              // Recupera tutti i voucher disponibili per l'agenzia
              const allVouchers = await findVoucherDisponibiliByIdAgenzia(userLoggedIn.id_agenzia);
              
              // Filtra per il corso selezionato
              const vouchersForCourse = allVouchers.filter(v => v.id_corso === selectedCourse.corso.id_corso);
              
              // Ordina per data_scadenza (più vicina prima) - FIFO
              vouchersForCourse.sort((a, b) => {
                  const dateA = new Date(a.data_scadenza);
                  const dateB = new Date(b.data_scadenza);
                  return dateA - dateB;
              });
              
              setVouchersList(vouchersForCourse);
              
              // Mantieni compatibilità con il vecchio codice (primo voucher per calcolo totale)
              if (vouchersForCourse.length > 0) {
                  const firstVoucher = vouchersForCourse[0];
                  const totalAvailable = vouchersForCourse.reduce((sum, v) => sum + (v.qt_available || 0), 0);
                  setVoucher({
                      ...firstVoucher,
                      qt_available: totalAvailable
                  });
              } else {
                  setVoucher(null);
              }
          } catch (error) {
              console.error('Errore nel caricamento voucher:', error);
              setVouchersList([]);
              setVoucher(null);
          }
      }
  };

  const fetchVoucherSuperpartner = async () => {
      if (selectedCourse?.corso?.id_corso) {
          // Qui useremo una nuova funzione da un nuovo hook che dobbiamo creare
          // Per ora la logica è commentata, ma la struttura è pronta

          const response = await getVoucherStock({
              id_corso: selectedCourse.corso.id_corso,
              id_superpartner: userLoggedIn.id_superpartner
          });
          if (Array.isArray(response) && response.length > 0) {
                setVoucher(response[0]);
            } else {
                // Se la risposta è vuota o non valida, impostiamo a null.
                setVoucher(null);
            }


        // Placeholder per farti vedere che la logica è agganciata

      }
  };

  const renderAgenzie = () => {
    if(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER || userLoggedIn.role === ROLES.SUPERPARTNER) {
      return (
      <div className='col-12 my-3'>
           <CustomSearch
            field={"denominazione"}
            label={"Cerca agenzia"}
            searchApi={getAgenzieByParams}
            placeholder={"Nome dell'agenzia"}
            selectedItem={selectedAgenzia}
            setSelectedItem={setSelectedAgenzia}
            />
           { selectedAgenzia && (
              <>
              <span className='small text-muted d-block mb-1'><b>Agenzia selezionata</b></span>
              <span>{selectedAgenzia.denominazione} ({selectedAgenzia.indirizzo}, {selectedAgenzia.cap}, {selectedAgenzia.citta}, {selectedAgenzia.provincia})</span>
              </>
           )
           }
       </div>
      )
    } 
    return null;
  }

  const handleFormChange = e => {
  const { name, value } = e.target;

  if (name === 'sconto') {
    console.log('SCONTO onChange - valore da input event:', `"${value}"`); // Logga il valore grezzo

    if (value === '') {
      setFormCreateUtente(prevState => ({ ...prevState, sconto: '' }));
      return;
    }

    // === CONTROLLO CON ESPRESSIONE REGOLARE ===
    // Questo regex permette solo cifre e al massimo un punto decimale.
    // Non permette lettere o altri simboli. Adatto per numeri positivi.
    // Esempi validi: "123", "123.45", ".5", "0", "" (ma "" è gestito sopra)
    // Esempi non validi: "1a", "a12", "abc", "1.2.3"
    const numericStringRegex = /^\d*\.?\d*$/;

    if (!numericStringRegex.test(value)) {
      // Se la stringa 'value' non rispetta il formato puramente numerico,
      // non aggiornare lo stato. Le lettere verranno bloccate qui.
      console.log('SCONTO onChange - Regex fallita per:', `"${value}"`, '. Stato non aggiornato.');
      return; // Impedisce l'aggiornamento dello stato con valori non numerici
    }

    // Solo se il formato della stringa è numerico, procedi con parseFloat e altri controlli
    const numValue = parseFloat(value);
    console.log('SCONTO onChange - Valore parsato (numValue):', numValue);

    // parseFloat di una stringa come "." o "" (se il regex lo permettesse) dà NaN.
    // Il nostro regex attuale fa sì che `value` sia "simile" a un numero.
    // Un controllo isNaN è ancora utile per casi limite come value="." (parseFloat(".") è NaN)
    if (isNaN(numValue) && value !== '.') { // Se è NaN e non è solo un punto che l'utente sta digitando
      console.log('SCONTO onChange - numValue è NaN (e value non è ".") per:', `"${value}"`, '. Stato non aggiornato.');
      return;
    }

    // Controllo del minimo (min="0" è già sull'input)
    // Evita di controllare numValue < 0 se numValue è NaN (es. per value=".")
    if (value !== '.' && numValue < 0) {
      console.log('SCONTO onChange - numValue < 0. Stato non aggiornato.');
      return;
    }

    // Controllo del massimo
    const maxAttr = e.target.getAttribute('max');
    if (maxAttr !== null) {
      const maxValue = parseFloat(maxAttr);
      // Evita di controllare numValue > maxValue se numValue è NaN
      if (!isNaN(maxValue) && value !== '.' && numValue > maxValue) {
        console.log('SCONTO onChange - numValue > maxValue. Stato non aggiornato.');
        return;
      }
    }

    // Se tutti i controlli sono superati, aggiorna lo stato.
    // Lo stato 'sconto' conterrà la stringa 'value', che ora sappiamo essere in formato numerico.
    console.log('SCONTO onChange - Tutti i controlli superati. Aggiorno stato con:', `"${value}"`);
    setFormCreateUtente(prevState => ({ ...prevState, sconto: value }));

  } else {
    // Gestione per altri input
    setFormCreateUtente(prevState => ({ ...prevState, [name]: value }));
  }
};

  const handleRoleChange = (event) => {
      const selectedOption = event.target.value;
      setSelectedRole(selectedOption)
      setFormCreateUtente((prevState) => ({ ...prevState, ruolo: selectedOption }));
  }

  const handleStatoPagamentoChange = (event) => {
    const selectedOption = event.target.value;
    setFormCreateUtente((prevState) => ({ ...prevState, stato_pagamento: selectedOption }));
}

  const handlePaymentOptionChange = (e) => {
      const newOption = e.target.value;

      // --- NUOVA LOGICA DI RESET ---
      // Ogni volta che cambio la modalità di pagamento principale,
      // azzero per sicurezza lo sconto inserito in precedenza.
      setFormCreateUtente(prevState => {
          const { sconto, ...restOfState } = prevState;
          return restOfState;
      });
      // --- FINE NUOVA LOGICA ---

      setPaymentOption(newOption);
  };

  const handleVoucherOptionChange = (e) => {
      const newOption = e.target.value;

      // Se l'utente seleziona "Non applicare" (valore "0")...
      if (newOption === '0') {
          // ...allora rimuoviamo la proprietà 'sconto' dallo stato del form.
          setFormCreateUtente(prevState => {
              const { sconto, ...restOfState } = prevState;
              return restOfState;
          });
      }
      setVoucherOption(newOption);
  };

  // const handleSelfOptionChange = (e) => {//NEW
  //   setSelfOption(e.target.value);
  // };

 /*
  const handleSelfOptionChange = (e) => {//NEW
    const newValue = e.target.value;
    setSelfOption(newValue);

    // Rimuovi il corso se cambia selezione da Stripe a Voucher o viceversa
    if (selectedCourse?.id_classe) {
      removeCourse(selectedCourse.id_classe); // simula il click sull'icona trash
    }
  };
*/

  const handleSelfOptionChange = (e) => {
    const newOption = e.target.value;

    // --- NUOVO CONTROLLO PREVENTIVO ---
    // Controlla se l'utente sta cercando di passare a "Voucher" (valore "0")
    // quando non ne ha di disponibili E ha già aggiunto un corso al carrello.
    if (newOption === "0" && (!remainingVoucherPartner || remainingVoucherPartner <= 0) && corsiUtentiAssignedPerUser.length > 0) {
        
        // Se le condizioni sono vere, mostra l'alert e NON cambiare la selezione.
        alertService.warn("Operazione non possibile: nessun voucher disponibile per il corso già assegnato. Rimuovilo dal riepilogo per cambiare modalità.", { autoClose: true });
        return; // Interrompe l'esecuzione della funzione, mantenendo la vecchia selezione
    }
    // --- FINE NUOVO CONTROLLO ---

    // Se il controllo passa, esegui la tua logica originale
    setSelfOption(newOption);

    // Rimuovi il corso ATTUALMENTE SELEZIONATO (ma non ancora aggiunto al carrello)
    // per forzare l'utente a ricontrollare i dettagli con la nuova modalità di pagamento.
    if (selectedCourse?.id_classe) {
      removeCourse(selectedCourse.id_classe); 
    }
  };
  
  const handleCheckboxCorsiChange = (isChecked) => {
    setShouldAssignCourse(isChecked);
  };

  const handleCheckboxAgenzieChange = (isChecked) => {
    setShowAgenzieList(isChecked);
  };

const onAssignCourse = async () => {
     
    // --- CONTROLLO DI SICUREZZA FINALE E CORRETTO ---
    // Se l'utente sta provando a usare un voucher...
    
    
    if ((userLoggedIn?.role === ROLES.PARTNER) && 
        paymentOption === "self" && 
        selfOption === "0") {
        
        // ...controlliamo direttamente lo stato 'voucher' che contiene l'oggetto completo dal backend.
        // Se non esiste, o non ha voucher disponibili (qt_available), blocchiamo l'operazione.
        if (!voucher || !voucher.qt_available || voucher.qt_available <= 0) {
            alertService.error("Assegnazione bloccata: nessun voucher disponibile per questo corso.", { autoClose: true });
            return; // Interrompe l'esecuzione e impedisce l'assegnazione
        }
    } 

    if ((userLoggedIn?.role === ROLES.SUPERPARTNER) && 
        paymentOption === "self" && 
        selfOption === "0") {
        
        // ...controlliamo direttamente lo stato 'voucher' che contiene l'oggetto completo dal backend.
        // Se non esiste, o non ha voucher disponibili (qt_available), blocchiamo l'operazione.
        if (!voucher || !voucher.qt_disponibile || voucher.qt_disponibile <= 0) {
            alertService.error("Assegnazione bloccata: nessun voucher disponibile per questo corso.", { autoClose: true });
            return; // Interrompe l'esecuzione e impedisce l'assegnazione
        }
    }
    // --- FINE BLOCCO DI SICUREZZA ---

    
    if(selectedCourse) {
        if (!corsiUtentiAssignedPerUser.some(corso => corso?.id_classe === selectedCourse?.id_classe)) {
            let corsoDaAggiungere = {...selectedCourse};
            
            // Logica per Admin/Developer
            if(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DEVELOPER){
                if(selectedRole === "corsista") {
                    if(!formCreateUtente.stato_pagamento){
                        alertService.warn("Seleziona uno stato di pagamento per il corso", {autoClose: true});
                        return;
                    }
                    corsoDaAggiungere.stato_pagamento = formCreateUtente.stato_pagamento;
                    corsoDaAggiungere.sconto = formCreateUtente?.sconto;
                }
            }
            
            // Logica per Partner/Superpartner
            if(userLoggedIn?.role === ROLES.PARTNER || userLoggedIn?.role === ROLES.SUPERPARTNER){
                corsoDaAggiungere.pagamento_partner = (paymentOption === "corsista" ? "0" : "1");
                corsoDaAggiungere.pagamento_self = selfOption;
                corsoDaAggiungere.sconto_corsista = voucherOption;
                corsoDaAggiungere.sconto_massimo_partner = maxScontoPartner;
                corsoDaAggiungere.sconto = formCreateUtente?.sconto;
                if (userLoggedIn.role === ROLES.SUPERPARTNER && paymentOption === "self" && selfOption === "0") {
                    corsoDaAggiungere.usa_voucher_superpartner = true;
                }
                if(paymentOption === "corsista" && voucherOption === "1") {
                    if(!formCreateUtente?.sconto) {
                      alertService.warn("Inserisci un valore per lo sconto", {autoClose: true});
                      return;
                    }
                    corsoDaAggiungere.sconto = formCreateUtente?.sconto;
                }
            }
            
            setCorsiUtentiAssignedPerUser(prev => [...prev, corsoDaAggiungere]);
            alertService.success("Corso aggiunto al riepilogo!", {autoClose: true});
            setSelectedCourse(null); // Pulisce la selezione
        } else {
            alertService.warn("Il corso è già stato aggiunto al riepilogo.", {autoClose: true});
        }
    } else {
        alertService.warn("Seleziona un corso da assegnare all'utente.", {autoClose: true});
    }
  };

  const removeCourse = (classIdToRemove) => {
    setCorsiUtentiAssignedPerUser(prevCourses => prevCourses.filter(course => course.id_classe !== classIdToRemove));
  };

  const renderPartnerPaymentOptions = () => (
  <div className="col-12 my-3">
       <span className='small text-muted d-block mb-1'><b>Pagamento</b></span>
      <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
            <input
              type="radio"
              className="btn-check"
              name="paymentOption"
              id="selfPayment"
              value="self"
              autoComplete="off"
              checked={paymentOption === 'self'}
              onChange={handlePaymentOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="selfPayment">
              Pagamento a proprio carico
            </label>

            <input
              type="radio"
              className="btn-check"
              name="paymentOption"
              id="corsistaPayment"
              value="corsista"
              autoComplete="off"
              checked={paymentOption === 'corsista'}
              onChange={handlePaymentOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="corsistaPayment">
              Pagamento a carico del corsista
            </label>
          </div>
  </div>
  )

  const renderPartnerVoucherOptions = () => (
  <div className="col-12 my-3">
       <span className='small text-muted d-block mb-1'><b>Applica sconto</b></span>
      <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
            <input
              type="radio"
              className="btn-check"
              name="voucherOption"
              id="yes-voucher"
              value="1"
              autoComplete="off"
              checked={voucherOption === "1"}
              onChange={handleVoucherOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="yes-voucher">
              Applica
            </label>

            <input
              type="radio"
              className="btn-check"
              name="voucherOption"
              id="no-voucher"
              value="0"
              autoComplete="off"
              checked={voucherOption === "0"}
              onChange={handleVoucherOptionChange}
            />
            <label className="btn btn-outline-primary" htmlFor="no-voucher">
              Non applicare
            </label>
          </div>
  </div>
  )

  const renderPartnerSelfOptions = () => (//NEW
    <div className="col-12 my-3">
         <span className='small text-muted d-block mb-1'><b>Seleziona modalità di pagamento</b></span>
        <div className="btn-group d-flex gap-3" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name="selfOption"
                id="transfer"
                value="1"
                autoComplete="off"
                checked={selfOption === "1"}
                onChange={handleSelfOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="transfer">
                Carta (Stripe)
              </label>
  
              <input
                type="radio"
                className="btn-check"
                name="selfOption"
                id="voucher"
                value="0"
                autoComplete="off"
                checked={selfOption === "0"}
                onChange={handleSelfOptionChange}
              />
              <label className="btn btn-outline-primary" htmlFor="voucher">
                Voucher
              </label>
            </div>
    </div>
  )

  const renderStatoPagamento = () => {
    if(userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DEVELOPER) {
      return (
      <div className='col-12 my-3'>
        <span className='small text-muted d-block mb-1'><b>Stato pagamento</b></span>
        <select name="stato_pagamento" className="form-control" value={formCreateUtente.stato_pagamento || ''} onChange={handleStatoPagamentoChange}>
        <option value="">Seleziona uno stato di pagamento</option>
          <option value="Pagato">Pagato</option>
          <option value="Non_pagato">Non pagato</option>
          <option value="Parzialmente_pagato">Parzialmente pagato</option>
        </select>
      </div>
      )
    }
    return null;
  }

  const handleSuperpartnerChange = (e) => {
    setFormCreateUtente((prevState) => ({ ...prevState, id_superpartner: e.target.value }));
  }

  const renderSuperpartner = () => {
    return (
      <div>
            <span className='small text-muted d-block mb-1'><b>Superpartner</b></span>
            {
             loadingStateSuperpartner.isLoadingSuperpartner ? (
              <div className="text-center py-3">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Caricamento...</span>
                </div>
              </div>
             ) : (
              <select name="superpartner" className="form-control" value={formCreateUtente.id_superpartner || ''} onChange={handleSuperpartnerChange}>
                <option value="nessuno">Nessuno</option>
                {superpartnerList.map(superpartner => (
                  <option key={superpartner.id_superpartner} value={superpartner.id_superpartner}>{superpartner.nome}</option>
                ))}
              </select>
            )
          }
      </div>
    )
  }

  /** Select obbligatoria per associare il nuovo utente (tipo_utente superpartner) a un superpartner dal DB */
  const renderSuperpartnerSelectForNewUser = () => {
    return (
      <div>
        <span className='small text-muted d-block mb-1'><b>Superpartner</b></span>
        {loadingStateSuperpartner.isLoadingSuperpartner ? (
          <div className="text-center py-3">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </div>
          </div>
        ) : (
          <select name="superpartner" className="form-control" value={formCreateUtente.id_superpartner || ''} onChange={handleSuperpartnerChange} required>
            <option value="">Seleziona superpartner</option>
            {superpartnerList.map(superpartner => (
              <option key={superpartner.id_superpartner} value={superpartner.id_superpartner}>{superpartner.nome}</option>
            ))}
          </select>
        )}
      </div>
    )
  }
/*
  const renderVoucher = () => {//NEW
    if(loadingStateVoucher?.isLoadingScontoByIdCorso) {
      return (
        <div className="text-center py-3">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      );
    }
    if (paymentOption == "self" && selfOption === "0") {
      if(remainingVoucherPartner == 0 || remainingVoucherPartner === undefined){
        return (
          <div className="alert alert-warning mt-3" role="alert">
            <i className="bi bi-exclamation-triangle me-2"></i>
            <small>Nessun voucher disponibile per questo corso.</small>
          </div>
        );
      }
      return (
        <div className="alert alert-primary" role="alert">
            <i className="bi bi-info-circle me-2"></i>
            <small>Hai ancora a disposizione {remainingVoucherPartner} voucher per questo corso</small>
        </div>
      );
    }
  }
*/

const renderVoucher = () => {
    if (paymentOption === "self" && selfOption === "0" && selectedCourse) {
        if (loadingStateVoucher?.isLoadingVouchers) {
            return <div className="text-center py-3"><Spinner size="sm" /></div>;
        }

        // Calcola il totale disponibile
        const totalAvailable = vouchersList.reduce((sum, v) => sum + (v.qt_available || 0), 0);

        if (vouchersList.length > 0 && totalAvailable > 0) {
            return (
                <div className="col-12 mt-3">
                    <Card className="border-success">
                        <Card.Header className="bg-success-subtle">
                            <i className="bi bi-ticket-perforated-fill me-2"></i>
                            Riepilogo Voucher Disponibili
                        </Card.Header>
                        <Card.Body>
                            <Card.Title>
                                Hai <strong>{totalAvailable}</strong> voucher utilizzabili per questo corso.
                            </Card.Title>
                            {vouchersList.length > 1 && (
                                <Accordion className="mt-3">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <small>Dettagli ordini ({vouchersList.length} pacchetti)</small>
                                        </Accordion.Header>
                                        <Accordion.Body className="p-2">
                                            {vouchersList.map((v, index) => (
                                                <div key={v.id_utenti_voucher || index} className="mb-2 p-2 border rounded">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <small className="d-block">
                                                                <strong>Ordine #{index + 1}</strong>
                                                            </small>
                                                            <small className="text-muted d-block">
                                                                Disponibili: <Badge bg="info">{v.qt_available}</Badge>
                                                            </small>
                                                            <small className="text-muted d-block">
                                                                Scadenza: {new Date(v.data_scadenza).toLocaleDateString('it-IT')}
                                                            </small>
                                                            {v.note && (
                                                                <small className="text-muted d-block mt-1">
                                                                    <i className="bi bi-info-circle me-1"></i>
                                                                    {v.note}
                                                                </small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            )}
                            {vouchersList.length === 1 && vouchersList[0] && (
                                <ul className="list-unstyled mb-0 small mt-2">
                                    <li>
                                        <i className="bi bi-calendar-check me-2"></i>
                                        <strong>Scadenza pacchetto:</strong> {new Date(vouchersList[0].data_scadenza).toLocaleDateString('it-IT')}
                                    </li>
                                    {vouchersList[0].note && (
                                        <li className="mt-1">
                                            <i className="bi bi-info-circle me-2"></i>
                                            <strong>Note:</strong> {vouchersList[0].note}
                                        </li>
                                    )}
                                </ul>
                            )}
                        </Card.Body>
                    </Card>
                </div>
            );
        } else {
            return (
                <div className="alert alert-warning mt-3">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    Nessun voucher disponibile per questo corso.
                </div>
            );
        }
    }
    return null;
};

const renderSuperpartnerVoucher = () => {
    if (paymentOption === "self" && selfOption === "0" && selectedCourse) {
        if (loadingStateVoucher?.isLoadingScontoByIdCorso) {
            return <div className="text-center py-3"><Spinner size="sm" /></div>;
        }
        // Usiamo il nuovo stato 'voucher' che contiene l'intero oggetto
        if (voucher && voucher.qt_disponibile > 0) {
            return (
                <div className="col-12 mt-3">
                    <Card className="border-success">
                        <Card.Header className="bg-success-subtle">
                            <i className="bi bi-ticket-perforated-fill me-2"></i>
                            Riepilogo Voucher Disponibili
                        </Card.Header>
                        <Card.Body>
                            <Card.Title>
                                Hai <strong>{voucher.qt_disponibile}</strong> voucher utilizzabili per questo corso.
                            </Card.Title>
                            <ul className="list-unstyled mb-0 small">
                                {voucher.note && (
                                    <li className="mt-1">
                                        <i className="bi bi-info-circle me-2"></i>
                                        <strong>Note:</strong> {voucher.note}
                                    </li>
                                )}
                            </ul>
                        </Card.Body>
                    </Card>
                </div>
            );
        } else {
            return (
                <div className="alert alert-warning mt-3">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    Nessun voucher disponibile per questo corso.
                </div>
            );
        }
    }
    return null;
};

  const renderSconti = () => {
    if(loadingStateSconti.isLoadingScontoByIdCorso) {
      return (
        <div className="text-center py-3">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      );
    }

    if (paymentOption == "corsista" && voucherOption === "1" && !maxScontoPartner) {
      return (
        <div className="alert alert-warning mt-3" role="alert">
          <i className="bi bi-exclamation-triangle me-2"></i>
          <small>Non è disponibile alcuno sconto per questo corso.</small>
        </div>
      );
    }
    
    return (
      paymentOption === "corsista" && voucherOption === "1" && (
        <div className="my-3">
          <div className="alert alert-primary" role="alert">
            <i className="bi bi-info-circle me-2"></i>
            <small>
              Lo sconto massimo applicabile è di <strong>{maxScontoPartner}€</strong>. 
              La differenza tra lo sconto massimo e quello applicato costituirà la tua provvigione.
            </small>
          </div>
          
          <div className="form-group">
            <span className='d-block text-muted mb-2'>
              <b>Inserisci sconto per il corsista (in €)</b>
            </span>
            <input 
              name="sconto" 
              value={formCreateUtente.sconto || ''} 
              onChange={handleFormChange} 
              className="form-control" 
              type="number"
              min="0"
              max={maxScontoPartner}
              step="0.01"
              onKeyDown={(e) => {
                if(['e', 'E', '+', '-'].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              placeholder={`Sconto massimo: ${maxScontoPartner}€`} 
              aria-label="Sconto"
            />
            <small className="text-muted mt-1 d-block">
              Esempio: se applichi uno sconto di 100€ su uno sconto massimo di 300€, la tua provvigione sarà di 200€
            </small>
          </div>
        </div>
      )
    );
  }

return (
  <>
    {/* --- SEZIONE ANAGRAFICA (Nascondi se isAssignmentOnly è true) --- */}
    {!isAssignmentOnly && (
      <>
        <div className='col-12'>
          <span className='small text-muted d-block mb-1'><b>Nome</b></span>
          <input name="nome" value={formCreateUtente.nome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Nome" aria-label="Nome"/>
        </div>
        <div className='col-12 my-3'>
          <span className='small text-muted d-block mb-1'><b>Cognome</b></span>
          <input name="cognome" value={formCreateUtente.cognome || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Cognome" aria-label="Cognome"/>
        </div>
        <div className='col-12 my-3'>
          <span className='small text-muted d-block mb-1'><b>Email</b></span>
          <input name="email" value={formCreateUtente.email || ''} onChange={handleFormChange} className="form-control" type="text" placeholder="Email" aria-label="Email"/>
        </div>
        <div className='col-12 my-3'>
          <span className='small text-muted d-block mb-1'><b>Ruolo</b></span>
          <select name="ruolo" className="form-control" value={formCreateUtente.ruolo || ''} onChange={handleRoleChange}>
            <option value="">Seleziona un ruolo</option>
            {rolesList?.map((option, index) => (
              <option key={index} value={option}>{option === "course_designer" ? "course designer" : option}</option>
            ))}
          </select>
        </div>

        {/* Selezione Agenzia/Superpartner (ADMIN/DEV) */}
        {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
          selectedRole === "partner" && (
            <div className='my-2'>
              {renderAgenzie()}
              {renderSuperpartner()}
            </div>
          )
        )}

        {/* Selezione Superpartner (ADMIN/DEV): quando crei un utente superpartner, scegli a quale superpartner associarlo */}
        {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
          selectedRole === "superpartner" && (
            <div className='my-2'>
              {renderSuperpartnerSelectForNewUser()}
            </div>
          )
        )}

        {/* Selezione Agenzia (SUPERPARTNER) */}
        {userLoggedIn.role === ROLES.SUPERPARTNER && (
          selectedRole === "partner" && (
            <div className='my-2'>
              {renderAgenzie()}
            </div>
          )
        )}

        {/* Slider Assegnazione Agenzia a Corsista (ADMIN/DEV) */}
        {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
          (selectedRole === "corsista") && (
            <div className='my-2'>
              <CustomSlider
                handleSliderChange={handleCheckboxAgenzieChange}
                labelText="Vuoi assegnare un'agenzia all'utente?"
              />
              {showAgenzieList && (
                renderAgenzie()
              )}
            </div>
          )
        )}
      </>
    )}
    {/* --- FINE SEZIONE ANAGRAFICA --- */}


    {/* --- SEZIONE CORSI (ADMIN/DEV -> STAFF e CORSISTA) --- */}
    {(userLoggedIn.role === ROLES.ADMIN || userLoggedIn.role === ROLES.COURSE_DESIGNER || userLoggedIn.role === ROLES.DEVELOPER) && (
      (selectedRole === "tutor" || selectedRole === "docente" || selectedRole === "course_designer" || selectedRole === "corsista") && (
        <>
          <CustomSlider
            handleSliderChange={handleCheckboxCorsiChange}
            labelText="Vuoi assegnare dei corsi all'utente?"
            isChecked={shouldAssignCourse}
          />
          {shouldAssignCourse && (
            <>
              <div className='col-12 my-3'>
                <CustomSearch
                  field={"denominazione_corso"}
                  label={"Cerca corso"}
                  searchApi={getClassiByParamsNoAuth}
                  placeholder={"Nome del corso"}
                  selectedItem={selectedCourse}
                  setSelectedItem={setSelectedCourse}
                  showDate={true}
                />
                {selectedCourse && (
                  <>
                    <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
                    <span>{selectedCourse?.corso?.denominazione}
                      {
                        selectedCourse?.corso?.modalita_erogazione !== "Telematica_Asincrona" && (
                          <>
                            {" "}({selectedCourse?.data_inizio ? UtilityService.formatDate(selectedCourse?.data_inizio) : ""} - {selectedCourse?.data_fine ? UtilityService.formatDate(selectedCourse?.data_fine) : ""})
                          </>
                        )
                      }
                    </span>
                    {selectedRole === "corsista" && renderStatoPagamento()}
                  </>
                )}
              </div>
              <div className='col-12 my-3'>
                <button className='btn btn-primary my-3 w-100' onClick={onAssignCourse}>Assegna corso</button>
              </div>
              <div className='mt-3'>
                {corsiUtentiAssignedPerUser?.length > 0 ? (
                  <>
                    <span className='d-block text-muted'><b>Lista corsi</b></span>
                    {corsiUtentiAssignedPerUser?.map(corso => (
                      <div key={corso.id_classe} >
                        <HorizontalCourseCard
                          cardStyle={"shadow"}
                          course={corso}
                          selectedRole={selectedRole}
                          onRemoveCourse={removeCourse}
                          userLoggedIn={userLoggedIn}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <p className='mt-5 text-center'>Nessun corso assegnato all'utente.</p>
                )}
              </div>
            </>
          )}
        </>
      )
    )}

    {/* --- SEZIONE CORSI (PARTNER/SUPERPARTNER -> CORSISTA) --- */}
    {(userLoggedIn?.role === ROLES.PARTNER || userLoggedIn?.role === ROLES.SUPERPARTNER) &&
      (selectedRole === "corsista") && (
        <>
          {/* Mostra il form di selezione solo se il carrello è vuoto (o se vuoi permettere selezioni multiple modifica qui) */}
          {corsiUtentiAssignedPerUser.length === 0 && (
            <>
              {/* 1. SELEZIONE DEL CORSO */}
              <div className='col-12 my-3'>
                <span className='small text-muted d-block mb-1'><b>1. Seleziona il corso da iscrivere</b></span>
                <select
                  className="form-control"
                  value={selectedCourse?.id_classe || ''}
                  onChange={(e) => {
                    const selected = classiDisponibili.find(c => c.id_classe === parseInt(e.target.value));
                    setSelectedCourse(selected);
                  }}
                >
                  <option value="">Seleziona un corso</option>
                  {classiDisponibili.map(classe => (
                    <option key={classe.id_classe} value={classe.id_classe}>
                      {classe.corso.denominazione}
                      {classe.corso.modalita_erogazione !== "Telematica_Asincrona" &&
                        ` (${UtilityService.formatDate(classe.data_inizio)} - ${UtilityService.formatDate(classe.data_fine)})`
                      }
                    </option>
                  ))}
                </select>
              </div>

              {/* 2. OPZIONI DI PAGAMENTO */}
              {selectedCourse && (
                <>
                  <div className='col-12 mt-4'>
                    <span className='small text-muted d-block mb-1'><b>2. Scegli opzioni di pagamento</b></span>
                    {renderPartnerPaymentOptions()}
                    {paymentOption === "corsista" && renderPartnerVoucherOptions()}
                    {paymentOption === "self" && renderPartnerSelfOptions()}
                  </div>

                  <div className='col-12 mt-3'>
                    {renderSconti()}
                    {userLoggedIn.role === ROLES.PARTNER ? renderVoucher() : renderSuperpartnerVoucher()}
                  </div>

                  <div className='col-12 my-3'>
                    <button className='btn btn-primary my-3 w-100' onClick={onAssignCourse} disabled={!selectedCourse}>
                      Assegna corso
                    </button>
                  </div>
                </>
              )}
            </>
          )}

          {/* 3. RIEPILOGO ISCRIZIONI */}
          <div className='mt-3'>
            {corsiUtentiAssignedPerUser.length > 0 ? (
              <>
                <span className='d-block text-muted'><b>Riepilogo iscrizione</b></span>
                {corsiUtentiAssignedPerUser.map(corso => (
                  <div key={corso.id_classe}>
                    <HorizontalCourseCard
                      cardStyle={"shadow"}
                      course={corso}
                      userLoggedIn={userLoggedIn}
                      selectedRole={selectedRole}
                      isCreateUserView={true}
                      onRemoveCourse={removeCourse}
                    />
                  </div>
                ))}
              </>
            ) : (
              // Messaggio vuoto
              corsiUtentiAssignedPerUser.length === 0 && <p className='mt-5 text-center'>Nessun corso assegnato.</p>
            )}
          </div>
        </>
      )}
  </>
);
}

export default CreateUser;